import './scss/index.scss';
import { dcFactory } from 'dc';
import TimelineYearComponent from "./js/timeline-year.component";

dcFactory.register(TimelineYearComponent);
